//import AgentLayout from '@/components/Agent/Layout.vue';
import AgentLayout from '../common/Layout.vue';
import { agentStore } from '../store';

import { flightRoutes } from '../flight/router';
import {trainRoutes} from '../train/router';
import {hotelRoutes} from '../hotel/router';
import {reportsRoutes} from '../reports/router';

const routes = [
    {
        path: '/agent',
        name: "AgentIndex",
        component: AgentLayout,
        children: [
            {
                path: "",
                name: "AgentPublicHome",
                meta: { title: 'Dreasyfly - Home' },
                component: () => import('../common/Home.vue'),
                beforeEnter: (to, from, next) => {
                    const auth = agentStore();
                    if (auth.isLoggedIn) {
                        next({ name: 'agenthome' });
                    } else {
                        next();
                    }
                }
            },
            {
                // sso login route
                path:"sso",
                name: "AgentSSOLogin",
                meta: { title: 'Dreasyfly - SSO Login' },
                component: () => import('../common/SSOCallback.vue'),
            },
            {
                path: "home",
                name: "agenthome",
                meta: { requiresAuth: true, title: 'Dreasyfly - Dashboard' },
                component: () => import('../flight/views/index.vue'),
            },
            trainRoutes,
            flightRoutes,
            hotelRoutes,
            reportsRoutes,
            {
                path: ':pathMatch(.*)*',
                name: 'AgentNotFound',
                meta: { title: '404 - Not Found' },
                component: () => import('../common/NotFound.vue'),
            }

        ]
    },
];


export default routes;
